<template>
    <main class="w-screen">
        <div class="container">
            <div class="max-w-sm mx-auto text-center">
                <div class="p-12 bg-white text-black rounded-lg">
                    <div class="flex items-center justify-between mb-8 pb-8 border-b">
                        <h1 class="h1 flex-1 text-left">Apollo EMS</h1>

                        <logo class="w-20 block" />
                    </div>

                    <div>
                        <h2 class="h2">{{ props.error!.statusCode }}</h2>
                        <p>{{ props.error!.message }}</p>

                        <div class="mt-4">
                            <StyledButton
                                color="primary"
                                @click.prevent="onGoBack"
                            >
                                Go Back
                            </StyledButton>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script setup lang="ts">
    import type { NuxtError } from '#app';
    import Logo from '~/assets/img/logo.svg?skipsvgo';
    import LogoWhite from '~/assets/img/logo-white.svg?skipsvgo';

    const router = useRouter();

    const props = defineProps({
        // eslint-disable-next-line vue/require-default-prop
        error: Object as () => NuxtError,
    });

    useHead({
        htmlAttrs: {
            lang: 'en',
            class: 'error-page',
        },
    });

    const onGoBack = () => {
        router.back();
    };
</script>

<style lang="postcss">
    html.error-page,
    html.error-page body {
        @apply m-0 p-0 min-h-screen;
    }

    html.error-page body {
        @apply flex items-center w-full;
        @apply bg-gradient-to-br from-[#182C3F] to-[#375C7B];
    }
</style>
